import { IonInput, IonSpinner, IonToggle } from '@ionic/react'
import { PriceTrackers } from '@vae/server/dist/client'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../analytics/utils/firebaseUtils'
import { trpc } from '../../modules/trpc'
import ModalWrapper from '../../wrappers/modalWrapper/ModalWrapper'
import useTrackers from './hooks/useTrackers'
import { getColor } from './utils/getColor'
import { getSortedTrackers } from './utils/getSortedTrackers'

const TrackerModal = () => {
	const { data, isLoading, mutate } = useTrackers()
	const utils = trpc.useContext()
	const [options, setOptions] = useState<PriceTrackers[]>([])
	const prevOptionsRef = useRef<PriceTrackers[]>([])
	const { t } = useTranslation('modals_trackerModal')

	useEffect(() => {
		if (data) {
			const newData = getSortedTrackers([...data])
			setOptions(newData)
			prevOptionsRef.current = newData
		}
	}, [data])

	useEffect(() => {
		const changedOptions = options.filter((option, index) => {
			const prevOption = prevOptionsRef.current[index]
			return (
				prevOption && (option.value !== prevOption.value || option.enabled !== prevOption.enabled)
			)
		})

		changedOptions.forEach(option => {
			editTracker(option.id)
		})

		prevOptionsRef.current = options
	}, [options])

	const editTracker = (id: number) => {
		mutate.mutate(
			{ id: id, data: options.find(e => e.id === id) as PriceTrackers },
			{
				onSuccess: () => {
					utils.trackers.invalidate()
					utils.synerall.getSpotPrices.invalidate()
				},
			}
		)
	}

	const handleInputChange = (id: number, value: number) => {
		setOptions(options.map(option => (option.id === id ? { ...option, value } : option)))
	}

	const handleToggleChange = (id: number, enabled: boolean) => {
		setOptions(options.map(option => (option.id === id ? { ...option, enabled } : option)))
	}

	return (
		<ModalWrapper>
			{isLoading ? (
				<IonSpinner />
			) : (
				<div className='options '>
					{options.map((e, i) => (
						<div className='element bg-white dark:bg-brand-secondary-200-dark' key={i}>
							<span className='title tracking-wide text-text-dark dark:text-white'>
								{t(e.limitType)}
							</span>
							<div className='info'>
								<div className='left'>
									<IonInput
										style={{ borderColor: getColor(e.limitType) }}
										maxlength={3}
										inputMode='numeric'
										className='text-text-dark dark:text-white'
										value={e.value}
										onIonChange={change =>
											handleInputChange(e.id, parseInt(change.detail.value ?? e.value.toString()))
										}
									/>
									<span className='text-text-grey-200 dark:text-text-grey-100'>snt/kWh</span>
								</div>
								<IonToggle
									checked={e.enabled}
									onIonChange={change => {
										logEvent('click-tracker-toggle', {
											value: change.detail.checked,
											label: e.limitType,
										})

										handleToggleChange(e.id, change.detail.checked)
									}}
									className='toggle-item [--track-background:#d6d6d6] dark:[--track-background:#09292b] [--handle-background:#a0a0a0] dark:[--handle-background:#063a3e] [--track-background-checked:#a8da9a] dark:[--track-background-checked:#0a5a5f] [--handle-background-checked:#52ae32] dark:[--handle-background-checked:#3cb49f]'
									color={
										i === 0 ? 'red' : i === 1 ? 'yellow' : i === 2 ? 'light-green' : 'dark-green'
									}
								/>
							</div>
						</div>
					))}
				</div>
			)}
		</ModalWrapper>
	)
}

export default TrackerModal
